// AUTO-GENERATED by scripts/set-env.js — DO NOT EDIT OR COMMIT.
// To change non-sensitive config edit scripts/set-env.js;
// credentials live in .env (local) or GitHub Secrets (CI).
/* eslint-disable */
import { Environment } from './environment.model';

export const environment: Environment = {
  "useEmulators": false,
  "useEmulatorHost": "localhost:8081",
  "enableSockets": true,
  "defaultWelbyEmail": "company@getwelby.com",
  "defaultOrdersWelbyEmail": "orders@welby.care",
  "defaultPhotoUrl": "https://firebasestorage.googleapis.com/v0/b/welby-dev.appspot.com/o/back_end%2Fimage.png?alt=media&token=804868e9-8403-4572-9169-80500066d88c",
  "trial_patient_loads": 5,
  "welby_admin_client_id": "rECk757NZD7WiBO7gUuW",
  "welby_admin_client_name": "Welby Health",
  "welby_survey": "https://docs.google.com/forms/d/e/1FAIpQLSdIbNB_mpt399pgfQEsEmowcauWNaxp_yZcK179hFuANTvPdQ/viewform",
  "patientTestId": "0S52nP9dfeTaz98b3o5f75TwHZE3",
  "terms_of_use": "https://acrobat.adobe.com/id/urn:aaid:sc:US:20fccee6-76cf-433d-a0c4-75fa4bacab97",
  "baa": "https://acrobat.adobe.com/link/review?uri=urn:aaid:scds:US:a13375c6-65fe-4432-a4df-02a9f2829bef",
  "powerBIReportUrl": "https://app.powerbi.com/view?r=eyJrIjoiOTBhM2ZjNzUtYTFiYS00ODA0LTk2NzctODQ5MjgzNTJhNDQ3IiwidCI6IjNmZTEwZGQyLTk2ZDAtNGY3Ny05OGY1LTg1MTRiZTQ1OTEyYyIsImMiOjZ9&pageName=ReportSection6e1aa9caa6a9c9b3aa10",
  "authRetry": {
    "maxAttempts": 3,
    "baseDelayMs": 300,
    "maxDelayMs": 3000
  },
  "twilioDevice": {
    "tokenRefreshMs": 300000,
    "minTokenLifetimeSec": 300,
    "registrationTimeoutMs": 10000,
    "takeoverProbeTimeoutMs": 1200,
    "visibleTakeoverDelayMs": 1500,
    "callPendingTimeoutMs": 60000,
    "tokenRefreshRetryMs": 60000,
    "tokenFetchTimeoutMs": 10000
  },
  "production": false,
  "welbyEndpoint": "https://dev.api.getwelby.com",
  "welbyBaseUrl": "https://dev.welby.care",
  "markusApiUrl": "https://markus-call-processor-dev-gdxs57j5fq-uc.a.run.app/api/v1",
  "call_transcriptions_endpoint": "https://markus-call-processor-dev-gdxs57j5fq-uc.a.run.app",
  "firebase": {
    "apiKey": "AIzaSyB_-q7PWiuMzwGblfEQUSo6Z1yNJCYwu6s",
    "authDomain": "welby-dev.firebaseapp.com",
    "databaseURL": "https://welby-dev.firebaseio.com",
    "projectId": "welby-dev",
    "storageBucket": "welby-dev.appspot.com",
    "messagingSenderId": "844292793724",
    "appId": "1:844292793724:web:34bf55e6e53d88d37fb0f9",
    "measurementId": "G-4G9RFWS0CB"
  },
  "stripeKey": "pk_test_YZ8AWD4QSbzy4AZIW9P64hhV00ScSrAald",
  "firebaseURL": "https://us-central1-welby-dev.cloudfunctions.net",
  "storageBucket": "welby-dev.appspot.com"
};
